export function isIframe() {
  return window.location !== window.parent.location;
}
